"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLoader = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const adapter_1 = require("../../api/adapter");
const bind_1 = require("../../internal/utils/bind");
const Manifest = tslib_1.__importStar(require("./state-flow/manifest/manifest"));
/**
 * Executes manifest request and returns the tuple of manifest and status code
 */
async function doRequest(url) {
    try {
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) {
            return [null, response.status];
        }
        const json = await response.json();
        // @todo: add json validation
        return [json, response.status];
    }
    catch (err) {
        return [null, -1];
    }
}
/**
 * Makes sure that URL params are set correctly and returns the new URL
 */
function prepareUrl(url, params) {
    const parsed = new URL(url);
    for (const [k, v] of Object.entries(params)) {
        parsed.searchParams.set(k, v);
    }
    return parsed.toString();
}
class MediaLoader {
    constructor(ctx) {
        this.ctx = ctx;
        this.enabled = false;
        this.timeoutId = 0;
        (0, bind_1.makeBounded)(this);
    }
    initStateFlow(sf) {
        this.sf = sf;
        sf.handleEnter(Manifest.Fetching, this.startPolling);
        sf.onCommit(Manifest.Fetching, this.restart);
        sf.handleEnter(Manifest.NotFound, this.stopPolling);
        sf.handleEnter(Manifest.Forbidden, this.stopPolling);
        sf.handleEnter(Manifest.InternalError, this.stopPolling);
    }
    start() {
        if (this.enabled) {
            return;
        }
        this.enabled = true;
        this.timeoutId = adapter_1.device.setTimeout(this.process, 0);
    }
    stop() {
        this.enabled = false;
    }
    [Symbol.dispose]() {
        this.stop();
    }
    async process() {
        if (!this.enabled) {
            return;
        }
        if (this.sf.manifest.deadline != null && Date.now() > this.sf.manifest.deadline) {
            this.sf.dispatch("manifestDeadline", {});
            return;
        }
        const url = prepareUrl(this.sf.manifest.url, this.sf.manifest.options.params);
        const [manifest, status] = await doRequest(url);
        const result = await this.sf.dispatchAsync("manifestUpdate", { manifest, status });
        if (!result.ok && result.kind !== state_flow_1.ResultKind.Ignored) {
            this.ctx.logger.error(`Signal manifestUpdate: ${String(result)}`, { signal: "manifestUpdate", result: String(result) });
        }
        this.timeoutId = adapter_1.device.setTimeout(this.process, this.sf.manifest.nextUpdate);
    }
    startPolling(states) {
        if (!this.enabled) {
            this.start();
            return state_flow_1.Result.ok();
        }
        return state_flow_1.Result.ignore("media loader is already started");
    }
    restart(states) {
        adapter_1.device.clearTimeout(this.timeoutId);
        this.timeoutId = adapter_1.device.setTimeout(this.process, states.manifest.nextUpdate);
    }
    stopPolling(states) {
        if (this.enabled) {
            this.stop();
            return state_flow_1.Result.ok();
        }
        return state_flow_1.Result.ignore("media loader is already stopped");
    }
}
exports.MediaLoader = MediaLoader;
MediaLoader.displayName = "MediaLoader";
//# sourceMappingURL=media-loader.js.map